import {
  signInWithEmailAndPassword,
  signOut as firebaseSignOut
} from 'firebase/auth';
import {
  collection,
  query,
  where,
  getDocs,
  doc,
  getDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp
} from 'firebase/firestore';
import { auth, db } from '../config/firebase';
import { Event } from '../types/event.types';

export const signInModerator = async (email: string, password: string): Promise<void> => {
  const credential = await signInWithEmailAndPassword(auth, email, password);
  const authorized = await isModeratorEmail(credential.user.email || '');
  if (!authorized) {
    await firebaseSignOut(auth);
    throw new Error('mod.error_not_mod');
  }
};

export const isModeratorEmail = async (email: string): Promise<boolean> => {
  if (!email) return false;
  const modRef = doc(db, 'moderators', email);
  const modDoc = await getDoc(modRef);
  return modDoc.exists();
};

export const getPendingEvents = async (): Promise<Event[]> => {
  const eventsRef = collection(db, 'activities');
  const q = query(eventsRef, where('status', '==', 2));
  const snapshot = await getDocs(q);
  const events: Event[] = [];
  snapshot.forEach(d => {
    events.push({ id: d.id, ...d.data() } as Event);
  });
  events.sort((a, b) => {
    const tA = (a.createdAt as any)?.toMillis?.() || 0;
    const tB = (b.createdAt as any)?.toMillis?.() || 0;
    return tA - tB;
  });
  return events;
};

export const getApprovedEvents = async (): Promise<Event[]> => {
  const eventsRef = collection(db, 'activities');
  const [snap1, snap5] = await Promise.all([
    getDocs(query(eventsRef, where('status', '==', 1), where('published', '==', true))),
    getDocs(query(eventsRef, where('status', '==', 5))),
  ]);
  const events: Event[] = [];
  snap1.forEach(d => events.push({ id: d.id, ...d.data() } as Event));
  snap5.forEach(d => events.push({ id: d.id, ...d.data() } as Event));
  // Orden descendente por updatedAt (más reciente primero)
  events.sort((a, b) => {
    const tA = (a.updatedAt as any)?.toMillis?.() || 0;
    const tB = (b.updatedAt as any)?.toMillis?.() || 0;
    return tB - tA;
  });
  return events;
};

export const deactivateEvent = async (eventId: string): Promise<void> => {
  await updateDoc(doc(db, 'activities', eventId), {
    status: 2,
    published: false,
    updatedAt: serverTimestamp()
  });
};

export const approveEvent = async (eventId: string): Promise<void> => {
  await updateDoc(doc(db, 'activities', eventId), {
    status: 1,
    published: true,
    updatedAt: serverTimestamp()
  });
};

// Aprueba el contenido y mueve el evento a status APPROVED (5)
// El organizador aún debe ingresar el token para publicar
export const approveAndSetAwaitingToken = async (eventId: string): Promise<void> => {
  await updateDoc(doc(db, 'activities', eventId), {
    status: 5,
    updatedAt: serverTimestamp()
  });
};

export const deleteEvent = async (eventId: string): Promise<void> => {
  await deleteDoc(doc(db, 'activities', eventId));
};
